import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=2844373d&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=2844373d&prod&lang=scss&scoped=true"
import style1 from "./Banner.vue?vue&type=style&index=1&id=2844373d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844373d",
  null
  
)

export default component.exports